import { TimelineMax, Power0,  RoughEase } from "gsap/TweenMax"

class CellAnimation {
  constructor() {
    // The base URL for the cell states
    this.baseUrl = "/cells/"

    // Current breakpoint
    this.breakpoint = 'desktop'

    // The container for the cell
    this.cells = [
      document.querySelector('#cell1'),
      document.querySelector('#cell2'),
      document.querySelector('#cell3'),
    ]

    // The animation duration per path
    this.duration = 15

    // The animation paths
    this.paths = []

    // The sprites to animate the fade transition
    this.states = [
      'healthy-cell.png',
      'orange-cell.png',
      'black-cell.png',
      'cell-decay-01.png',
      'cell-decay-02.png',
      'cell-decay-03.png',
      'cell-decay-04.png'
    ]

    // preload images
    const preload = []

    this.states.forEach((url) => {
      preload.push((new Image()).src = this.baseUrl + url)
    })

    // Calculate Paths on resize
    window.addEventListener('resize', this.recalculate.bind(this))
    this.recalculate()
  }

  recalculate() {
    if (window.innerWidth < 767) {
      this.breakpoint = "mobile"
    } else if (window.innerWidth < 1024) {
      this.breakpoint = "tablet"
    } else {
      this.breakpoint = "desktop"
    }

    console.log('recalculating for ' + this.breakpoint)
    this.calculatePaths()
  }

  calculatePaths() {
    // Setup cells
    this.cells.forEach(cell => {
      const current = cell.querySelector('.current')
      const next = cell.querySelector('.next')
      current.style.backgroundImage = 'url("' + this.baseUrl + this.states[0] + '")'
      next.style.backgroundImage = 'url("' + this.baseUrl + this.states[0] + '")'
    })

    if (typeof this.main !== 'undefined') {
      this.main.pause().seek(0).kill()
    }

    this.cells.forEach(cell => {
      cell.style.transform = ""
    })

    this.paths.forEach(path => {
      path.seek(0).kill()
    })

    this.paths = []

    this.paths.push(this.createAnimation(this.cells[0], [
      [0, 0],
      [8, 15],
      [7, 35],
      [30, 50],
      [48, 55],
      [70, 60],
      [90, 63],
      [101, 75]
    ], this.duration, {
      desktop: this.duration * 0.31875,
      tablet: this.duration * 0.34,
      mobile: this.duration * 0.3625
    }))

    this.paths.push(this.createAnimation(this.cells[1], [
      [0, 0],
      [8, 15],
      [15, 35],
      [30, 50],
      [48, 55],
      [70, 60],
      [90, 68],
      [101, 66]
    ], this.duration, {
      desktop: this.duration * 0.308,
      tablet: this.duration * 0.34125,
      mobile: this.duration * 0.375
    }))

    this.paths.push(this.createAnimation(this.cells[2], [
      [0, 0],
      [9, 13],
      [14, 30],
      [30, 50],
      [48, 55],
      [70, 65],
      [90, 60],
      [101, 58]
    ], this.duration, {
      desktop: this.duration * 0.311,
      tablet: this.duration * 0.34125,
      mobile: this.duration * 0.367
    }))

    this.main = this.loop()
  }

  // function to create cell movement and fadeout based on bezier curve mapped using getXY
  createAnimation(cell, points, duration, transitionTimes) {
    const that = this
    const parsedPoints = []
    const transitionTime = transitionTimes[this.breakpoint]

    points.forEach(point => parsedPoints.push(this.getXY(point[0], point[1])))

    return new TimelineMax({
      repeat: 0,
      paused: true
    })

    // Reset the cell
    .call(() => {
      const current = cell.querySelector('.current')
      const next = cell.querySelector('.next')
      current.style.backgroundImage = 'url("' + that.baseUrl + that.states[0] + '")'
      next.style.backgroundImage = 'url("' + that.baseUrl + that.states[0] + '")'
    }, null, null, 0)

    // Scale the cell over time
    .fromTo(cell, duration, {
      scale: 1
    }, {
      scale: 0.75,
      ease: RoughEase.ease.config({
        clamp: true,
        points: 50,
        randomize: false,
        strength: 0.25,
        taper: 'none',
        template: Power0.easeNone,
      })
    }, 0)

    // Move along path
    .to(cell, this.duration, {
      bezier: {
        autoRotate: false,
        curviness: 1.5,
        values: parsedPoints
      },
      ease: RoughEase.easeOut
    }, 0)

    // Fade out
    .to(cell, 5, {
      opacity: 0
    }, this.duration - 5)

    // Transition the cells
    .call(function () {
      // Slow down for a bit when blasted
      this.timeline.timeScale(0.05)
      that.shoot(0, 0.6)
      that.transitionCell(cell, 1, -10, () => {
        this.timeline.timeScale(1)
        that.transitionCell(cell, 2, 10, () => {
          that.transitionCell(cell, 3, -5, () => {
            that.transitionCell(cell, 4, 5, () => {
              that.transitionCell(cell, 5, -2.5, () => {
                that.transitionCell(cell, 6, 0, () => {
                  console.log('end')
                })
              })
            })
          })
        })
      })
    }, null, null, transitionTime)
  }

  shoot(start, duration) {
    new TimelineMax({ repeat: 5 })
      .fromTo(document.querySelector('.energy-beam'), duration / 3, {
        scale: 0,
        x: 0
      }, {
        scale: 10,
        x: 100,
      })
      .eventCallback('onComplete', function () {
        this.seek(0).kill()
      })
      .play()
  }

  // Helper function to transition cell states
  transitionCell(cell, idx, deg, cb) {
    const current = cell.querySelector('.current')
    const duration = this.duration / 11
    const next = cell.querySelector('.next')

    // Setup next cell
    next.style.backgroundImage = 'url("' + this.baseUrl + this.states[idx] + '")'

    return new TimelineMax({
      // Reset and callback
      onComplete: () => {
        current.style.backgroundImage = 'url("' + this.baseUrl + this.states[idx] + '")'
        current.style.opacity = 1
        next.style.opacity = 0

        if (typeof cb === 'function') {
          cb()
        }
      }
    })

    // Rotate slightly
    .to(cell, duration, {
      rotation: deg
    }, 0)

    // Fade cell in
    .to(next, duration, {
      opacity: 1
    }, 0)

    // Fade cell out
    .to(current, duration, {
      opacity: 0
    }, 0)
  }

  // The animation loop
  loop() {
    // Create a timeline that is 1.5x the duration to make an overlap
    return new TimelineMax({
      repeat: -1,
    })

    // Set the duration of all 3 animations - 1/2 for overlapping
    .to(document.body, this.duration * 1.5, { opacity: 1 })

    // Play the first Cell
    .call(() => {
      this.paths[0].seek(0).play()
    }, null, null, 0)

    // Play the second cell
    .call(() => {
      this.paths[1].seek(0).play()
    }, null, null, this.duration * 0.5)

    // Play the third cell
    .call(() => {
      this.paths[2].seek(0).play()
    }, null, null, this.duration * 1.0)
  }

  // Helper function for mapping out graphed curves
  getXY(x, y) {
    const jutter = 0
    const el = document.querySelector('.canvas')
    const h = el.clientHeight
    const l = el.clientWidth

    return {
      x: l * (x / 100) + Math.random() * jutter,
      y: h * (y / 100) + Math.random() * jutter
    }
  }
}

export default CellAnimation


// WEBPACK FOOTER //
// ./js/classes/cell-animation.class.js